import { MAX_TXT_BYTES, decodeTextBytes, isTxtFile, readFileBytes } from './decode';
import { parseSpeakerNotes } from './parse';

// TXT faylni o'qib, sahifalarga ajratadi. errors bo'sh bo'lmasa — fayl qabul qilinmaydi.
// Natija: { fileName, pages, markers, errors, warnings, noMarkers?, encoding }
export async function readNotesFile(file) {
    const fileName = file?.name || '';
    if (!isTxtFile(file)) {
        return { fileName, pages: {}, markers: {}, warnings: [], errors: [{ line: null, message: 'Faqat .txt fayl yuklash mumkin.' }] };
    }
    if (file.size > MAX_TXT_BYTES) {
        return { fileName, pages: {}, markers: {}, warnings: [], errors: [{ line: null, message: 'Fayl hajmi 2 MB dan katta.' }] };
    }

    let decoded;
    try {
        decoded = decodeTextBytes(await readFileBytes(file));
    } catch (error) {
        return { fileName, pages: {}, markers: {}, warnings: [], errors: [{ line: null, message: "Faylni o'qib bo'lmadi." }] };
    }

    const parsed = parseSpeakerNotes(decoded.text);
    const warnings = decoded.encoding === 'utf-8'
        ? parsed.warnings
        : [{ line: null, message: `Fayl UTF-8 emas — ${decoded.encoding} sifatida o'qildi.` }, ...parsed.warnings];
    return { fileName, ...parsed, warnings, encoding: decoded.encoding };
}
